<template>
  <div>
    <van-popup
      v-model="creates"
      position="right"
      :style="{ height: '100%',width:'100%', background: '#f5f5f5',overflow: 'hidden'}"
    >
      <van-nav-bar fixed>
        <div slot="title">创建请假</div>
        <div slot="right" @click="cancelDate">关闭</div>
      </van-nav-bar>
      <div class="select-people">
        <van-radio-group v-model="radio" class="select-group">
          <van-radio name="1" class="select-group-radio" @click="selectRadio">连续性请假</van-radio>
          <van-radio name="2" class="select-group-radio" @click="selectRadio">周期性请假</van-radio>
        </van-radio-group>

        <div v-if="radio ==='1'">
          <van-cell
            clearable
            type="text"
            title="开始时间"
            placeholder="开始时间"
            v-model="evensStartMsg"
            @click="eventsShowStartDate"
          />
          <van-cell
            clearable
            type="text"
            title="结束时间"
            v-model="evensEndMsg"
            @click="eventsShowEndDate"
            placeholder="结束时间"
          />
        </div>
        <div v-else class="rate-box">
          <van-cell
            clearable
            type="text"
            title="开始时间"
            placeholder="开始时间"
            v-model="startMsg"
            @click="showStartDate"
          />
          <van-cell
            clearable
            type="text"
            title="结束时间"
            v-model="endMsg"
            @click="showEndDate"
            placeholder="结束时间"
          />
          <div class="rate-tit">重复频率</div>
          <div class="rate-cont">
            <div class="rate-item" v-for="(item,index) in typeList.CycleList" v-bind:key="index">
              <van-checkbox class="rate-item-tit" v-model="item.Checked">{{item.Name}}</van-checkbox>
              <div class="rate-item-cont" v-if="item.Checked">
                <div
                  class="btn-row"
                  v-for="(itemTime,indexTime) in item.TimeList"
                  v-bind:key="indexTime"
                >
                  <div
                    class="btn"
                    @click="addStateTime(item,itemTime,indexTime)"
                  >{{itemTime.StartTime}}</div>-
                  <div class="btn" @click="addEndTime(item,itemTime,indexTime)">{{itemTime.EndTime}}</div>
                  <van-icon
                    class="del"
                    v-if="itemTime.isDel"
                    color="#F87C7C"
                    size="24px"
                    @click="delRow(item,itemTime,indexTime)"
                    name="clear"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sigle-bottom-btn">
        <van-button type="info" plain round @click="cancelDate">取消</van-button>
        <van-button type="info" round @click="okDate">确认</van-button>
      </div>

      <!-- 连续性请假---选择时间 -->
      <van-popup v-model="evensStartDate" position="bottom" :style="{ height: '45%' }">
        <van-datetime-picker
          @cancel="cancelPicker"
          @confirm="eventsPickerStart"
          v-model="evensStartModel"
          v-bind:min-date="eventsStartMinDate"
          type="datetime"
          :formatter="formatter"
        />
      </van-popup>
      <van-popup v-model="evensEndDate" position="bottom" :style="{ height: '45%' }">
        <van-datetime-picker
          @cancel="cancelPicker"
          @confirm="eventsPickerEnd"
          v-model="evensEndModel"
          v-bind:min-date="eventsEndMinDate"
          type="datetime"
          :formatter="formatter"
        />
      </van-popup>

      <!-- 周期性请假---选择时间 -->
      <van-popup v-model="startDate" position="bottom" :style="{ height: '45%' }">
        <van-datetime-picker
          @cancel="cancelPicker"
          @confirm="confirmPickerStart"
          v-model="startModel"
          v-bind:min-date="startMinDate"
          type="date"
          :formatter="formatter"
        />
      </van-popup>
      <van-popup v-model="endDate" position="bottom" :style="{ height: '45%' }">
        <van-datetime-picker
          @cancel="cancelPicker"
          @confirm="confirmPickerEnd"
          v-model="endModel"
          v-bind:min-date="endMinDate"
          type="date"
          :formatter="formatter"
        />
      </van-popup>

      <!-- 开始时间 -->
      <van-popup v-model="isStateTime" position="bottom" :style="{ height: '45%' }">
        <van-datetime-picker
          @cancel="cancelTime"
          @confirm="confirmTimeStart"
          v-model="stateTime"
          type="time"
        />
      </van-popup>
      <!-- 结束时间 -->
      <van-popup v-model="isEndTime" position="bottom" :style="{ height: '45%' }">
        <van-datetime-picker
          @cancel="cancelTime"
          @confirm="confirmTimeEnd"
          v-model="endTime"
          type="time"
        />
      </van-popup>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    isSelectTime: Boolean,
    datasList:Object,
  },
  name: "SelectTime",
  computed: {
    creates: {
      get: function() {
        return this.isSelectTime;
      },
      set: function(ed) {
        this.isModal = ed;
      }
    }
  },
  created(){
    var  nowTime = new Date(this.xy.moment().startOf('day'))
    this.evensStartModel  =  nowTime  //连续性请假开始时间
    this.evensEndModel = nowTime      //连续性请假结束时间
    this.startModel  =  nowTime  //连续性请假开始时间
    this.endModel = nowTime      //连续性请假结束时间
    this.selectTimeDist()
    try {
      this.typeList= JSON.parse(JSON.stringify(this.list))
    } catch (error) {
      this.typeList = this.list
    }
  },
  watch: {
    datasList(newVal){
      this.list.SETime = newVal.SETime
      newVal.CycleList.map((res)=>{
          this.list.CycleList.map((res2)=>{
          //  let arr =  Object.keys(res)
            if(JSON.stringify(res) !== "{}"){
              if(res.Name ===  res2.Name) {
                res2.Checked =res.Checked
                res2.Name = res.Name
                res2.TimeList = res.TimeList
                res2.Week = res.Week
              }
            }
          })
      })
      this.typeList = this.list
    }
  },
  data() {
    return {
      isModal: false,
      radio: "1",
      // 连续性请假
      evensStartMsg: "",
      evensEndMsg: "",
      evensStartDate: false,
      evensEndDate: false,
      evensStartModel: new Date(),
      evensEndModel: new Date(),
      eventsStartMinDate: "",
      eventsEndMinDate: "",

      startDate: false,
      startMsg: "",
      startModel: "",

      endDate: false,
      endMsg: "",
      endModel: "",
      startMinDate: "",
      endMinDate: "",
      typeList:{},
      list: {
        radio: 1,
        SETime: [],
        CycleList: [
          {
            Week: 1,
            Name: "每周一",
            Checked: false,
            TimeList: [
              {
                StartTime: "添加开始时间",
                EndTime: "添加结束时间",
                isDel: false
              }
            ]
          },
          {
            Week: 2,
            Name: "每周二",
            Checked: false,
            TimeList: [
              {
                StartTime: "添加开始时间",
                EndTime: "添加结束时间",
                isDel: false
              }
            ]
          },
          {
            Week: 3,
            Name: "每周三",
            Checked: false,
            TimeList: [
              {
                StartTime: "添加开始时间",
                EndTime: "添加结束时间",
                isDel: false
              }
            ]
          },
          {
            Week: 4,
            Name: "每周四",
            Checked: false,
            TimeList: [
              {
                StartTime: "添加开始时间",
                EndTime: "添加结束时间",
                isDel: false
              }
            ]
          },
          {
            Week: 5,
            Name: "每周五",
            Checked: false,
            TimeList: [
              {
                StartTime: "添加开始时间",
                EndTime: "添加结束时间",
                isDel: false
              }
            ]
          },
          {
            Week: 6,
            Name: "每周六",
            Checked: false,
            TimeList: [
              {
                StartTime: "添加开始时间",
                EndTime: "添加结束时间",
                isDel: false
              }
            ]
          },
          {
            Week: 7,
            Name: "每周日",
            Checked: false,
            TimeList: [
              {
                StartTime: "添加开始时间",
                EndTime: "添加结束时间",
                isDel: false
              }
            ]
          }
        ]
      },
      isStateTime: false,
      isEndTime: false,
      stateTime: "",
      endTime: "",
      addStateTimeItem: "",
      addEndTimeItem: "",
      StateTimeIndex: 0,
      EndTimeIndex: 0
    };
  },
  mounted() {},
  methods: {
    // 时间赋值
    selectTimeDist() {
      // 可向前请几天
      let m1 = this.xy.moment(new Date());
      let m2 = this.$parent.beforeDay;
      let dayNum = m1.subtract(m2, "days");
      if (this.radio === "1") {
        this.eventsStartMinDate = new Date(dayNum.startOf('day'));
        this.eventsEndMinDate = new Date(dayNum.startOf('day'));
      } else {
        this.startMinDate = new Date(dayNum);
        this.endMinDate = new Date(dayNum);
      }
    },

    // 选择
    selectRadio() {
      this.typeList.SETime = [];
      if (this.radio==='1') {
        this.typeList.SETime[0] = this.evensStartMsg;
        this.typeList.SETime[1] = this.evensEndMsg;
        // this.evensStartMsg = "";
        // this.evensEndMsg = "";
      } else {
         this.typeList.SETime[0] = this.startMsg;
        this.typeList.SETime[1] = this.endMsg;
        // this.startMsg = "";
        // this.endMsg = "";
      }
      this.selectTimeDist();
    },

    // 连续性请假
    eventsShowStartDate() {
      this.evensStartDate = true;
    },
    eventsShowEndDate() {
      this.evensEndDate = true;
    },

    // 选择时间
    showStartDate() {
      this.startDate = true;
    },
    showEndDate() {
      this.endDate = true;
    },
    cancelPicker() {
      // 选择器取消按钮点击事件
      this.evensStartDate = false;
      this.evensEndDate = false;
      this.startDate = false;
      this.endDate = false;
    },
    // 连续性请假起止时间
    eventsPickerStart() {
      this.evensStartMsg = this.evensStartModel.pattern("yyyy-MM-dd HH:mm");
      this.evensStartDate = false;
      this.typeList.SETime[0] = this.evensStartMsg;
    },
    eventsPickerEnd() {
      this.evensEndMsg = this.evensEndModel.pattern("yyyy-MM-dd HH:mm");
      this.evensEndDate = false;
      this.typeList.SETime[1] = this.evensEndMsg;
    },
    // 周期性请假起止时间
    confirmPickerStart(value) {
      // 确定按钮，时间格式化并显示在页面上
      var date = value;
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      var timer = date.getFullYear() + "-" + m + "-" + d;
      this.startMsg = timer;
      this.typeList.SETime[0] = this.startMsg;
      this.startDate = false;
    },
    confirmPickerEnd(value) {
      var date = value;
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      var timer = date.getFullYear() + "-" + m + "-" + d;
      this.endMsg = timer;
      this.typeList.SETime[1] = this.endMsg;
      this.endDate = false;
    },
    // 周期性请假---添加开始结束时间
    addStateTime(val, valTime, index) {
      this.isStateTime = true;
      this.addStateTimeItem = val;
      this.StateTimeIndex = index;
    },
    addEndTime(val, valTime, index) {
      this.isEndTime = true;
      this.addEndTimeItem = val;
      this.EndTimeIndex = index;
    },
    // 格式化选择器日期
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
      return value;
    },

    // 关闭时间选择
    cancelTime() {
      this.isStateTime = false;
      this.isEndTime = false;
    },
    // 添加开始时间确定
    confirmTimeStart(e) {
      for (var i = 0; i < this.typeList.CycleList.length; i++) {
        if (this.addStateTimeItem.Week === this.typeList.CycleList[i].Week) {
          this.typeList.CycleList[i].TimeList[
            this.StateTimeIndex
          ].StartTime = this.stateTime?this.stateTime:e;
        }
      }
      this.cancelTime();
      console.log(this.typeList.CycleList);
    },
    // 添加结束时间确定
    confirmTimeEnd(e) {
      for (let i = 0; i < this.typeList.CycleList.length; i++) {
        if (this.addEndTimeItem.Week === this.typeList.CycleList[i].Week) {
          // 缺少-----结束时间不小于开始时间的判断
          this.typeList.CycleList[i].TimeList[this.EndTimeIndex].EndTime = this.endTime?this.endTime:e;
          // 添加删除按钮
          this.typeList.CycleList[i].TimeList[this.EndTimeIndex].isDel = true;
          if (this.typeList.CycleList[i].TimeList.length < 3) {
            this.typeList.CycleList[i].TimeList.push({
              StartTime: "添加开始时间",
              EndTime: "添加结束时间"
            });
          }
          this.cancelTime();
          console.log(this.typeList.CycleList[i].TimeList);
        }
      }
      console.log(this.typeList.CycleList);
    },
    // 删除时间
    delRow(val, valTime, index) {
      console.log(val)
      for (var i = 0; i < this.typeList.CycleList.length; i++) {
        if (val.Week === this.typeList.CycleList[i].Week) {
          this.typeList.CycleList[i].TimeList.splice(index, 1);
          console.log(this.typeList.CycleList[i].TimeList.length);
          if (index === 2) {
            this.typeList.CycleList[i].TimeList.push({
              StartTime: "添加开始时间",
              EndTime: "添加结束时间"
            });
          }
          if (this.typeList.CycleList[i].TimeList.length < 1) {
            this.typeList.CycleList[i].TimeList.push({
              StartTime: "添加开始时间",
              EndTime: "添加结束时间"
            });
          }
        }
      }

    },
    // 取消选择时间
    cancelDate() {
      this.$emit("handleSelectTime", false);
    },
    // 确认时间
    okDate() {
      console.log(this.typeList)
      this.typeList.radio = this.radio;
      // 判断开始时间不能晚于结束时间
      let m1 = this.xy.moment(this.typeList.SETime[0]);
      let m2 = this.xy.moment(this.typeList.SETime[1]);
      let dayNum = m2.diff(m1, "seconds");
      if (dayNum < 0) {
        this.$toast.fail("开始时间不能晚于结束时间");
        return;
      }
      // 判断有开始结束时间
      if (this.typeList.SETime[0] !== '' && this.typeList.SETime[1] !== '' && this.typeList.SETime.length === 2) {
        let a = 0
        for(let i of this.typeList.CycleList){
          if(i.Checked){
             if(i.TimeList[0]['StartTime'] === '添加开始时间' ||i.TimeList[0]['EndTime'] === '添加结束时间' )
             {
                this.$toast.fail(`${i['Name']}请添加时间`);
                  return
             }

              let time = new Date()
              let ft1 = time.setHours(i.TimeList[0]['StartTime'].split(":")[0], i.TimeList[0]['StartTime'].split(":")[1])
              let ft2 = time.setHours(i.TimeList[0]['EndTime'].split(":")[0], i.TimeList[0]['EndTime'].split(":")[1])
              if(ft1>ft2){
                this.$toast.fail(`${i['Name']}的开始时间不能大于结束时间`);
                 return
              }
          } else {
            a++
          }
        }
        console.log(a)
        if (a === 7 && this.radio==='2' ) {
          this.$toast.fail("请选择请假时间");
        } else {
          // 子组件值传入父组件
          this.$emit("typeListFunction", this.typeList);
          // 关闭组件
          this.cancelDate();
        }
      } else {
        this.$toast.fail("请填写起止时间");
      }
    }
  }
};
</script>
<style scoped lang="less">
.select-people {
  position: fixed;
  top: 80px;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f9f9f9 !important;
  z-index: 111;
  overflow: auto;
  .select-group {
    display: inline-block;
    background: #fff;
    width: 100%;
    height: 100px;
    line-height: 100px;
    margin-top: 20px;
    .select-group-radio {
      width: 48%;
      display: inline-flex;
      height: 100px;
      line-height: 100px;
      padding-left: 50px;
      div {
        display: inline-block !important;
      }
    }
  }
}
.rate-box {
  background: #fff;
  margin-bottom: 110px;
  .rate-tit {
    padding: 36px 30px;
  }
  .rate-cont {
    .rate-item {
      .rate-item-tit {
        padding: 0 30px;
        height: 100px;
        line-height: 100px;
        border-top: 1px solid #f9f9f9;
      }
      .rate-item-cont {
        background: #f9f9f9;
        overflow: hidden;
        .btn-row {
          white-space: nowrap;
          margin: 20px 0;
          .btn {
            display: inline-block;
            background: rgba(245, 250, 255, 1);
            border: 1px solid rgba(228, 228, 235, 1);
            border-radius: 8px;
            width: 240px;
            height: 84px;
            text-align: center;
            line-height: 84px;
            margin: 0 30px;
            vertical-align: middle;
          }
          .del {
            vertical-align: middle;
          }
        }
      }
    }
  }
}
.sigle-bottom-btn {
  height: 110px;
  line-height: 110px;
  background: #000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;

  z-index: 999999 !important ;
  button {
    flex: 0.5;
    margin: 17px 30px;
  }
}
</style>
